<template>
  <div id="cont_steps" v-if="!loadingPage">
    <HeaderRegister :registrationObj="registrationObj" :title="$t('registerEventLegacy.title')" />
    <v-row v-if="age18">
      <v-col md="12">
        <v-stepper v-model="registrationObj.step" @reload="reloadstep($event)">
          <v-stepper-header>
            <template v-for="(step, index) in stepperSteps">
              <v-stepper-step
                :key="step.id"
                :complete="registrationObj.step > step.id"
                :step="step.id"
                :color="registrationObj.step > step.id ? step.header.completeColor : step.header.activeColor"
              >
                {{ step.header.label }} <span v-if="step.displayComponentIndexOnTitle">{{ step.componentIndex }}</span>
              </v-stepper-step>
              <v-divider :key="step.id + '-divider'" v-if="index < stepperSteps.length - 1"></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content v-for="(step, index) in stepperSteps" :key="index" :step="step.id" class="step-xs">
              <StepPromotersComponent 
                v-if="step.component == 'StepPromotersComponent'" 
                :windowWidth="windowWidth"
                :loadingProm="loadingProm" 
                :registrationObj="registrationObj"
                @getEventsByPromoter="getEventsByPromoter" 
              />
              <StepEventsComponent 
                v-else-if="step.component == 'StepEventsComponent'" 
                :windowWidth="windowWidth"
                :registrationObj="registrationObj" 
                :defaultRegistration="defaultRegistrationProcessed"
                :defaultPromoterId="defaultPromoterId" 
                :step="registrationObj.step"
                :userAge="userAge"
                @nextStep="nextStep"
                @selectEvent="selectEvent" 
                @updateLoad="updateLoad" 
              />
              <StepSpectatorsComponent 
                v-else-if="step.component == 'StepSpectatorsComponent'" 
                ref="stepSpectatorRef"
                @validateSpectators="validateSpectators" 
                @validateSpectatorsWaiver="validateSpectatorsWaiver"
                :registrationObj="registrationObj" 
                :step="registrationObj.step" 
                @nextStep="nextStep"
                @updateSpectators="updateSpectators" 
                @alertNotValidate="alertNotValidate"
                @showAlert="showAlert" 
                @refreshHeader="refreshHeader"
                @confirmNextStep="confirmNextStepParticipant" 
                :loadingToStepParticipant="loadingToStepParticipant"
                @refreshEventWaiverStatus="refreshEventWaiverStatus" 
                :eventDescription="eventDescription" 
                @getEventDescription="getEventDescription"
              />
              <StepPracticeComponent 
                v-else-if="step.component == 'StepPracticeComponent'" 
                ref="stepPracticeRef"
                :step="step" 
                :registrationObj="registrationObj" 
                @updatePracticeParticipants="updatePracticeParticipants"
                @nextStep="nextStep" 
                :eventDescription="eventDescription" 
                @getEventDescription="getEventDescription"
                @refreshEventWaiverStatus="refreshEventWaiverStatus" 
                @validateSpectatorsWaiver="validateSpectatorsWaiver"
                @showAlert="showAlert"
              />
              <StepParticipantsComponent 
                v-else-if="step.component == 'StepParticipantsComponent'"
                ref="stepParticipantRef" 
                @validateRiders="validateRiders" 
                :isMembership="!!isMembership"
                :registrationObj="registrationObj" 
                :step="registrationObj.step" 
                :stepperCounts="stepperCounts"
                @nextStep="nextStep"
                @updateParticipants="updateParticipants" 
                @alertNotValidate="alertNotValidate"
                :disabledStep3="disabledStep3" 
                @refreshHeader="refreshHeader"
                @refreshEventWaiverStatus="refreshEventWaiverStatus" 
                @showAlert="showAlert"
                :eventDescription="eventDescription" 
                @getEventDescription="getEventDescription"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row no-gutters v-else>
      <v-col md="12" class="pa-3" v-if="loading">
        <WarningAlert>
          <p class="mb-0 font-weight-bold">{{ $t("registerEventLegacy.content_1") }}</p>
          <p class="mb-0">{{ $t("registerEventLegacy.content_2") }}</p>
          <p class="mb-0">{{ $t("registerEventLegacy.content_3") }}</p>
          <p class="mb-0">{{ $t("registerEventLegacy.content_4") }}</p>
        </WarningAlert>
        <WarningProfileMinor />
        <v-row>
          <v-col>
            <ManagerAccount />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar timeout="6000" v-model="snackbar" :color="color_snackbar" top>
      {{ msg_snackbar }}
    </v-snackbar>
  </div>
</template>

<script>
import PaymentService from "@/services/PaymentService";
import LanguageService from '@/services/LanguageService';
import RegistrationService from '@/services/RegistrationService';
import MembershipWaiverService from '@/services/MembershipWaiverService';
import RelationshipService from "@/services/RelationshipService";
import AccountStatusService from "@/services/AccountStatusService";
import AuthService from '@/services/AuthService';
import moment from 'moment-timezone';
import LocalStorageService from "@/services/LocalStorageService";
import
  {
    VRow, VCol, VStepperItems, VStepper, VStepperContent,
    VStepperStep, VDivider, VStepperHeader, VSnackbar
  } from 'vuetify/lib';
import HeaderRegister from "@/components/eventRegistration/HeaderRegister";
import StepPromotersComponent from "@/components/eventRegistration/stepper/StepPromotersComponent";
import StepEventsComponent from "@/components/eventRegistration/stepper/StepEventsComponent";
import StepSpectatorsComponent from "@/components/eventRegistration/stepper/StepSpectatorsComponent";
import StepPracticeComponent from "@/components/eventRegistration/stepper/StepPracticeComponent";
import StepParticipantsComponent from "@/components/eventRegistration/stepper/StepParticipantsComponent";
import ManagerAccount from "@/components/authorization/ManagerAccount.vue";
import WarningProfileMinor from "@/components/alert/WarningProfileMinor.vue";
import WarningAlert from "@/components/alert/WarningAlert";
import { mapState } from 'vuex';
import EventWaiverService from "@/services/EventWaiverService";
import APIService from "@/services/APIService";
import Vue from 'vue'

export default {
  name: "RegisterEventLegacy",
  components: {
    HeaderRegister,
    StepPromotersComponent,
    StepEventsComponent,
    StepSpectatorsComponent,
    StepPracticeComponent,
    StepParticipantsComponent,
    ManagerAccount,
    VRow, VCol, VStepperItems, VStepper, VStepperContent,
    VStepperStep, VDivider, VStepperHeader, VSnackbar,
    WarningProfileMinor,
    WarningAlert
  },
  data()
  {
    return {
      row: null,
      valid: true,
      rows: [],
      rowPreferred_: "4.2",
      organization_: "4.1",
      registrationType: -1,
      organizations: -1,
      organizationModel: [],
      initReg: false,
      promoter: "LiveLaps Inc",
      day: 31,
      month: "oct",
      cant: "1.00",
      currency: "usd",
      comments_optional: "",
      yourClassItems: [],
      yourClass: 0,
      preferredPositionItems: [],
      preferredPosition: 0,
      isMembership: false,
      membershipNumber: 1234567,
      membershipNumberNom: "AMA :: Please provide your AMA number ",
      brand: [],
      eventOrganizationName: [],
      brandItems: [],
      membersItems: [],
      friendsItems: [],
      listResultSearch: [],
      buttonColor: "#000",
      danger: "#123",
      searchPromoter: "",
      promoterItems: [],
      promoterSel: null,
      eventSel: null,
      searchEvent: "",
      eventItems: [],
      ridersItems: [],
      ridersSelected: [],
      acceptDisclaimer: false,
      acceptSummary: false,
      itemsTest: [],
      dialogDelete: false,
      dialog: false,
      classCost: 0,
      addClassDisabled: false,
      returnSummary: false,
      registrantId: 0,
      queueId: 0,
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      userId: 0,
      partsSelected: [],
      partSel: [],
      summaryItems: [],
      loadingProm: false,
      objectLocal: {},
      registrationObj: {
        step: 1,
        promoters: [],
        promoterSel: null,
        events: [],
        eventSel: null,
        participants: [],
        partsSel: [],
        classE: [],
        brandsE: [],
        userId: 0,
        spectators: [],
        spectatorsSel: [],
        practicesSel: []
      },
      notDisclaimer: false,
      iconAlertColor: '',
      borderAlertColor: '',
      bgAlertColor: '',
      textareaRows: 1,
      windowWidth: window.innerWidth,
      checkboxAll: false,
      total: 0.00,
      subtotal: 0.00,
      tax: 0.00,
      loadSummary: false,
      hours: '00',
      minutes: '00',
      seconds: '00',
      value: 100,
      timer: 10,
      past: 9999999,
      subValue: null,
      eventId: null,
      birthdayCurrent: null,
      disabledStep3: false,
      loading: false,
      bandLoadUserStore: false,
      loadingToStepParticipant: false,
      eventDescription: '', 
      lastEventDescriptionCallTime: null,
      waitTimeBeforeAnotherApiCall: 5
    };
  },
  computed: {
    practiceSteps()
    {
      return this.registrationObj.eventSel ? (this.registrationObj.eventSel.practices || []).length : 0;
    },
    age18()
    {
      const nowDay = new Date();
      nowDay.setFullYear(nowDay.getFullYear() - 18);
      if (this.birthdayCurrent)
      {
        const birthday = new Date(this.birthdayCurrent);
        return birthday <= nowDay;
      }
      return false;
    },
    ...mapState({
      urlDomain: (state) => state.env.get("VUE_APP_ROOT"),
      defaultPromoterId: state => {
        let defaultPromoters = state.env.get('VUE_APP_DEFAULT_PROMOTER');
        if (!defaultPromoters || defaultPromoters === '') {
          return [];
        }
        return defaultPromoters.replaceAll('"','')
          .replaceAll("'",'')
          .split(',')
          .filter(el => !!el)
          .map(promoter => parseInt(promoter))
          .filter(id => !isNaN(id));
      },
      promoterId: state => state.env.get('VUE_APP_DEFAULT_PROMOTER'),
      defaultRegistration: state => state.env.get('VUE_APP_DEFAULT_REGISTRATION'),
      defaultPromoterUserId: (state) => state.registerEvent.promoterDefaultUserId,
      promoterList: (state) => state.registerEvent.promoterList,
      content5(state)
      {
        return this.$t("registerEventLegacy.content_5", { email: state.session.user.email })
      },
      spectatorRole: state => state.session.spectatorRole,
      userStore: state =>
      {
        return state.session.user;
      },
      urlBase: (state) => state.env.get('VUE_APP_BASE'),
      urlProfile: (state) => `${state.env.get('VUE_APP_BASE')}profile`,
      loadingPage: (state) =>
      {
        if (state && state.session) return state.session.loadingPage;
        return true;
      }
    }),
    content6()
    {
      return this.$t('registerEventLegacy.content_6', { link: this.urlProfile })
    },
    isSpectatorRegistration()
    {
      if (this.registrationObj.eventSel)
      {
        return this.registrationObj.eventSel.isSpectatorRegistration;
      }
      return false;
    },
    isPracticeRegistration()
    {
      if (this.registrationObj.eventSel && (this.registrationObj.eventSel.practices || []).length > 0)
      {
        return this.registrationObj.eventSel.isPracticeRegistration == 1;
      }
      return false;
    },
    stepperSteps()
    {
      var stepAvailable = 1;
      const stepsArr = [];

      let step = {
        id: stepAvailable,
        displayComponentIndexOnTitle: false,
        component: 'StepPromotersComponent',
        numberOfSteps: 1,
        header: {
          label: this.$t("registerEvent.step_1_title"),
          activeColor: this.buttonColor,
          completeColor: this.buttonColor
        },
      };
      stepAvailable++;
      stepsArr.push(step);

      step = {
        id: stepAvailable,
        componentIndex: 1,
        displayComponentIndexOnTitle: false,
        component: 'StepEventsComponent',
        numberOfSteps: 1,
        header: {
          label: this.$t("registerEvent.step_2_title"),
          activeColor: this.buttonColor,
          completeColor: this.buttonColor
        },
      };
      stepAvailable++;
      stepsArr.push(step);

      if (this.isSpectatorRegistration)
      {
        step = {
          id: stepAvailable,
          componentIndex: 1,
          displayComponentIndexOnTitle: false,
          component: 'StepSpectatorsComponent',
          numberOfSteps: 1,
          header: {
            label: this.$t("registerEvent.step_3_title"),
            activeColor: this.buttonColor,
            completeColor: this.buttonColor
          },
        };
        stepAvailable++;
        stepsArr.push(step);
      }

      if (this.isPracticeRegistration)
      {
        for (var i = 1; i <= step.numberOfSteps; i++)
        {
          step = {
            id: stepAvailable,
            componentIndex: i,
            displayComponentIndexOnTitle: true,
            component: 'StepPracticeComponent',
            numberOfSteps: this.practiceSteps,
            header: {
              label: this.$t("registerEvent.step_practice_title"),
              activeColor: this.buttonColor,
              completeColor: this.buttonColor
            },
          };
          stepAvailable++;
          stepsArr.push(step);
        }
      }

      step = {
        id: stepAvailable,
        componentIndex: 1,
        displayComponentIndexOnTitle: false,
        component: 'StepParticipantsComponent',
        numberOfSteps: 1,
        header: {
          label: this.$t("registerEvent.step_4_title"),
          activeColor: this.buttonColor,
          completeColor: this.buttonColor
        },
      };
      stepAvailable++;
      stepsArr.push(step);

      return stepsArr;
    },
    stepperCounts() {
      return this.stepperSteps.length;
    },
    defaultRegistrationProcessed() {
      return this.defaultRegistration && this.defaultPromoterId.length <= 1;
    },
    rulesCB() {
      return {
        organization: [
          val =>
            val > 0 ||
            this.$t("registerEvent.organization_required")
        ],
        yourClass: [
          val =>
            val > 0 ||
            this.$t("registerEvent.class_required")
        ],
        brand: [
          val => {
            if (this.registrationObj.brandsE.length > 0) {
              return val > 0 || this.$t("registerEvent.brand_required");
            } else {
              return true;
            }
          }
        ]
      };
    },
    dataStep() {
      return this.$store.state.dataStep;
    }
  },
  created()
  {
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.danger = this.$store.getters.env.get('VUE_APP_BUTTON_DANGER_COLOR');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');

    const nextLink = LocalStorageService.getItem('next_link');
    if (nextLink)
    {
      LocalStorageService.removeItem("next_link");
    }
    PaymentService.hasUnpaidRegistrations().then(response =>
    {
      if (response.data.success == 1)
      {
        this.hasUnpaidRegistrations = response.data.message;
        this.$store.dispatch('setUnPaidRegistrationAction', this.hasUnpaidRegistrations);
        if (this.hasUnpaidRegistrations != false)
        {
          this.$router.push({
            name: 'UnPaidRegistrationDashboard'
          });
        }
      } else
      {
        this.$store.dispatch('setUnPaidRegistrationAction', false);
        LocalStorageService.removeItem("add_part_reg");
        this.registrationType = LocalStorageService.getItem("registrationType");
        if (this.registrationType == 1 && LocalStorageService.getItem("rows") != null)
        {
          this.rows = LocalStorageService.getItem("rows");
        }
        this.organizations = LocalStorageService.getItem("organizations");
      }
    });
  },
  mounted()
  {
    this.$emit("titlePage", "registerEvent.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
    LocalStorageService.setItem('active_event_registration', false);
    if(this.dataStep) {
      this.registrationObj = this.dataStep;     
      this.$store.commit('SET_DATA_STEP', null);
      this.getEventsByPromoter(this.registrationObj.promoterSel, false, true);
    } 
    if(LocalStorageService.getItem("registration_legacy")) {
      this.registrationObj = LocalStorageService.getItem("registration_legacy");
      if (this.registrationObj.promoterSel) {
        this.getEventsByPromoter(this.registrationObj.promoterSel, false, true);
      }
    }
    this.$nextTick(() =>
    {
      window.addEventListener('resize', this.onResize);
    })
    this.$store.dispatch('setRolesAction');
    if (!this.userStore)
    {
      this.$store.dispatch('setUserAction');
    } else
    {
      this.loadUserStoreInit(this.userStore);
    }
  },
  updated() {},
  beforeDestroy()
  {
    LanguageService.postSetSession({ languageCode: this.$i18n.locale }).then((resp) =>
    {
      if (resp.data.success)
      {
        this.$store.dispatch('setLanguageId', resp.data.message.id);
      }
      this.$store.dispatch('setLanguageCode', this.$i18n.locale);
    });
    LocalStorageService.setItem("registration_legacy", this.registrationObj);
  },
  methods: {
    async getEventDescription()
    {
      const curtime = new Date();
      if(this.lastEventDescriptionCallTime)
      {
        const elapsedSeconds = (curtime - this.lastEventDescriptionCallTime) / 1000;
        if(elapsedSeconds < this.waitTimeBeforeAnotherApiCall)
        {
          return false;
        }
      }
      this.lastEventDescriptionCallTime = curtime;

      const eventId = this.registrationObj.eventSel.id;

      await APIService.fetch({
        method: "get",
        path: `${this.urlDomain}/laravel/public/api/v1/participant/events/${eventId}/description`,
      }).then((resp) => {
        if (resp.status === 200) {
          this.eventDescription = resp.data.message.eventDescription;
        }
      });
    },
    updatePracticeParticipants(data) {
      if (
        !this.registrationObj.practicesSel || 
        (Array.isArray(this.registrationObj.practicesSel) && 
        !this.registrationObj.practicesSel.find(reg => reg.practiceId === data.practiceId && reg.userId === data.userId))
      ) {
        this.$nextTick(() => {
        if(!Array.isArray(this.registrationObj.practicesSel)) {
            Vue.set(this.registrationObj, 'practicesSel', []);
        }
        this.registrationObj.practicesSel.push(data);
        });
      } else {
        if (Array.isArray(this.registrationObj.practicesSel)) {
          const index = this.registrationObj.practicesSel.findIndex(
            reg => reg.practiceId === data.practiceId && reg.userId === data.userId
          );
          if (index >= 0) {
            const { practiceId, userId, practicePrice } = this.registrationObj.practicesSel[index];
            let newValue = {
              practiceId,
              status: data.status,
              userId,
              practicePrice
            };
            
            this.$nextTick(() => {
              Vue.set(this.registrationObj.practicesSel, index, newValue);
            });
      }
      }
      }
    },
    onResize()
    {
      this.windowWidth = window.innerWidth;
      if (window.innerWidth > 600)
      {
        this.textareaRows = 2;
      }
    },
    async getLocalData() {
      // Reset scroll position
      const elem2 = document.getElementById("scrolling-techniques-7");
      elem2.scrollTop = 0;
      let _local = null;
      _local = LocalStorageService.getItem("registration_legacy");

      // Set loading status
      this.loadingProm = false;
      // If local data exists and user ID matches
      if (_local && _local.userId === this.userId) {
        this.registrationObj = _local;
        this.notDisclaimer = false;
        this.row = _local.preferredRow ?? null; // Optional chaining for undefined check
        const pLinked = this.showLinkedMembers(); // Ensure showLinkedMembers is async if using await
        this.getPromoters(); // Promoter selection
        await pLinked;
        // Handle event selection logic
        if (this.registrationObj.step > 2) {
          if(!this.registrationObj.promoterSel) {
            const parent = this;
            setTimeout(() => {
              Vue.set(parent.registrationObj,'step',1);
              parent.$store.dispatch('setLoadingPageAction', false);
              parent.$emit("changeLoadingStep", false);
            }, 500);
          } else {
            const promoterSel = this.registrationObj.promoterSel;
            if(
              (Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length > 0 && this.defaultPromoterId.includes(promoterSel.promoterId)) || 
              (!this.defaultPromoterId || (Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length == 0))
            ){
              this.getEventsByPromoter(this.registrationObj.promoterSel, false, true);
            } else {
              const parent = this;
              setTimeout(() => {
                Vue.set(parent.registrationObj,'step',1);
                parent.$store.dispatch('setLoadingPageAction', false);
                parent.$emit("changeLoadingStep", false);
              }, 500);
            }
          }
        } else if (this.registrationObj.step > 1) {
          this.getEventsByPromoter(this.registrationObj.promoterSel);
        }

      } else { // If no local data or user ID mismatch
        const pLinked = this.showLinkedMembers();
        this.getPromoters(true); // Pass 'true' to reload promoters
        await pLinked;
      }

      // Retrieve and parse the registration ID if available
      const _regId = LocalStorageService.getItem("regId_legacy");
      this.regId = _regId ? parseInt(_regId, 10) : null; // Ensures valid integer conversion
    },
    getAccountManagerUserIdFromRelationship(apiParticipant) {
      const x = apiParticipant || {};
      const ma = x.managerAccount;
      const emptyManagerAccount = ma == null || String(ma).trim() === '';
      let firstId = null;
      if (!emptyManagerAccount) {
        const first = String(ma).trim().split(',')[0];
        const n = parseInt(first, 10);
        if (Number.isInteger(n) && n > 0) firstId = n;
      }
      return firstId ?? x.accountManagerUserId ?? x.fkUsersIdMaster ?? (emptyManagerAccount ? undefined : this.userId);
    },
    async showLinkedMembers(forLocalData = false)
    {
      //Get ID part add in createRider
      let _part_add_news = [];
      let _part = LocalStorageService.getItem("part_add_new_legacy");
      if (_part != null)
      {
        _part_add_news = LocalStorageService.getItem("part_add_new_legacy");
        LocalStorageService.removeItem("part_add_new_legacy");
      }

      let _riders = [];
      LocalStorageService.setItem("previus_participants", this.registrationObj.participants);
      const itemFind = this.registrationObj.participants.find((el) => { return el.userId == this.userId });
      let pUser = Promise.resolve();
      if (!itemFind)
      {
        pUser = AuthService.getUserCurrent().then(resp =>
        {
          if (resp.data.success)
          {
            this.userId = resp.data.message.id;
            this.registrationObj.participants.push({
              selected: false,
              disabled: false,
              disabledLimit: false,
              userId: resp.data.message.id,
              lName: resp.data.message.lastName,
              fName: resp.data.message.firstName,
              relationship: 'You',
              email: resp.data.message.email || resp.data.message.emailAddress || "",
              emailAddress: resp.data.message.emailAddress || resp.data.message.email || "",
              accountManagerUserId: resp.data.message.id,
              status: "",
              membership: "",
              membershipColor: false,
              waivers: "",
              waiversColor: false,
              waiverSigned: false,
              classes: "",
              classesColor: false,
              backg: "",
              emergencyContact: "",
              relationshipType: resp.data.message.permissionName.toString().replace('GuestRegistrant', 'Spectator'),
              eventWaiver: "",
              eventWaiverCode: "",
              colorEventWaiver: false,
              managerAccount: 'You',
              birthday: resp.data.message.birthday,
              practiceSelected: false
            });
          }
        });
      } else
      {
        this.registrationObj.participants[0].managerAccount = 'You';
        this.registrationObj.participants[0].lName = this.userStore.lastName;
        this.registrationObj.participants[0].fName = this.userStore.firstName;
        this.registrationObj.participants[0].relationshipType = this.userStore.permissionName.toString().replace('GuestRegistrant', 'Spectator');
        this.registrationObj.participants[0].birthday = this.userStore.birthday;
      }
      
      let pRoles = RelationshipService.getUserRoles().then(response =>
      {
        let userRolesItems = [];
        if (response.data.success == 1)
        {
          userRolesItems = response.data.message;
          let roles = userRolesItems.filter(x =>
          {
            return x.userRoleCode === 'Participant' || x.userRoleCode === 'Spectator';
          }).map((x) =>
          {
            return x.id
          });
          return EventWaiverService.getRelationshipList({ rolesId: roles, withUserLogin: true, authorizedUser: true }).then(response =>
          {
            if (response.data.success == 1)
            {
              return response.data.message;
            }
            return [];
          });
        }
        return [];
      });

      await Promise.all([pUser, pRoles]).then(([/* user */, riders]) => {
        _riders = riders || [];
      });
      let _backg = "";
      this.registrationObj.participants = this.registrationObj.participants.filter((part) =>
      {
        if (part.userId == this.userId) return true;
        const partAux = _riders.find((x) => { return x.userId == part.userId });
        return !!partAux;
      });
      _riders.forEach(async x =>
      {
        _part_add_news.find(y =>
        {
          if (y == x.userId)
            _backg = "#f1f1f1";
        });
        const partFind = this.registrationObj.participants.find((el) => { return el.userId == x.userId });
        if (!partFind)
        {
          this.registrationObj.participants.push({
            selected: false,
            disabled: false,
            disabledLimit: false,
            userId: x.userId,
            lName: x.lName,
            fName: x.fName,
            relationship: x.relationship,
            email: x.email || x.emailAddress || "",
            emailAddress: x.emailAddress || x.email || "",
            accountManagerUserId: this.getAccountManagerUserIdFromRelationship(x),
            status: "",
            membership: "",
            membershipColor: false,
            waivers: "",
            waiversColor: false,
            waiverSigned: false,
            classes: "",
            classesColor: false,
            backg: _backg,
            emergencyContact: "",
            relationshipType: x.userRoleCode.replace(',', ', '),
            eventWaiver: "",
            eventWaiverCode: "",
            colorEventWaiver: false,
            managerAccount: x.managerAccount,
            birthday: x.birthday
          });
        } else
        {
          partFind.userId = x.userId;
          partFind.lName = x.lName;
          partFind.fName = x.fName;
          partFind.relationship = x.relationship;
          partFind.relationshipType = x.userRoleCode.replace(',', ', ');
          partFind.managerAccount = x.managerAccount;
          partFind.accountManagerUserId = this.getAccountManagerUserIdFromRelationship(x);
          partFind.birthday = x.birthday;
        }
      });
      if (forLocalData && this.registrationObj.eventSel)
      {
        const item = this.registrationObj.events.find((el) =>
        {
          return el.id == this.registrationObj.eventSel.id;
        });
        const data = item ? item : this.registrationObj.eventSel;
        this.selectEvent(data);
      }
    },
    getPromoters(bandNotUser = false)
    {
      this.registrationObj.promoters = [];
      if (
        this.defaultRegistration && Array.isArray(this.defaultPromoterId) && 
        this.defaultPromoterId.length == 1 && this.registrationObj && this.registrationObj.step <= 2
      )
      {
        let item = { userID: this.defaultPromoterUserId };
        let bEventId = !!this.eventId;
        this.getEventsByPromoter(item, bEventId);
      }
      else
      {
        RegistrationService.getPromoterListDays(30).then(resp =>
        {
          if (resp && resp.data && resp.data.success == 1)
          {
            let data = resp.data.message;
            const vm = this;
            data.forEach(resp =>
            {
              resp.select = false;
              resp.image = (resp.promoterImage != null && resp.promoterImage.length > 0) ? vm.$store.getters['env/VUE_APP_ROOT'] + "/" + resp.promoterImage : require("@/assets/images/orgPlaceholder.jpg.png");
            });
            this.orderPromoter(data);
            if(!this.registrationObj.promoterSel) {
              Vue.set(this.registrationObj,'step',1);
            }
            if(this.registrationObj.step > 1) {
              const promoterSel = this.registrationObj.promoterSel;
              if(Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length > 0 && !this.defaultPromoterId.includes(promoterSel.promoterId)) {
                if(this.defaultPromoterId.length > 1) {
                  Vue.set(this.registrationObj,'step',1);
                } else {
                  const promoterSelCorrect = data.find((el) => this.defaultPromoterId == el.promoterId);
                  Vue.set(this.registrationObj,'step',1);
                  if(promoterSelCorrect) {
                    Vue.set(this.registrationObj,'promoterSel',promoterSelCorrect);
                    this.getEventsByPromoter(promoterSelCorrect);
                  }
                }
              }
            }
            if (this.registrationObj.step <= 1 || bandNotUser)
            {
              this.$store.dispatch('setLoadingPageAction', false);
              this.$emit("changeLoadingStep", false);
            }
          }
        });
      }
    },
    getEventsByPromoter(item, init = false, forLocalData = false)
    {
      if (item)
      {
        if(this.registrationObj.userId == 0) {
          this.registrationObj.userId = this.userStore.id;
        }
        let data = {
          id: item.userID,
          days: 500,
          limit: 50,
          user: this.registrationObj.userId,
          bGetEventDescription: false
        };
        if(!(
          Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length == 1 && 
          this.defaultPromoterId.includes(item.userID)
        )) {
          let indexOf = this.registrationObj.promoters.findIndex((el) => { 
            return el.userID == item.userID; 
          });
          if(indexOf > -1) {
            this.registrationObj.promoters[indexOf].select = true;
          }
        }
        this.registrationObj.promoterSel = item;
        RegistrationService.getEventsByPromoter(data).then(resp =>
        {
          let result = [];
          if (resp.data.success == 1)
          {
            let data = resp.data.message;
            let tz = moment.tz.guess();
            const vm = this;
            if (data.length > 0)
              result = data.map(function (resp){
                resp.image = (resp.eventImage != null && resp.eventImage.length > 0) ? vm.$store.getters['env/VUE_APP_ROOT'] + "/" + resp.eventImage : require("@/assets/images/orgPlaceholder.jpg.png");

                let date1 = moment();
                let date2 = moment(resp.registrationOpen).tz('America/New_York', true);
                let date3 = moment(resp.registrationClose).tz('America/New_York', true);

                date2 = date2.clone().tz(tz);
                date3 = date3.clone().tz(tz);

                resp.registrationOpen = date2.format("YYYY-MM-DD HH:mm:ss");
                resp.registrationClose = date3.format("YYYY-MM-DD HH:mm:ss");
                resp.regOpen = date2.format("YYYY-MM-DD HH:mm:ss");
                resp.regClose = date3.format("YYYY-MM-DD HH:mm:ss");
                resp.nowDate = date1.format("YYYY-MM-DD HH:mm:ss");
                resp.loading = false;
                resp.disabled = false;
                return resp;
              });
            this.registrationObj.events = result;
            let band = false;
            if (forLocalData)
            {
              band = true;
            } else if (!init)
            {
              const step = this.registrationObj.step > 2 ? this.registrationObj.step : 2;
              this.nextStep(step);
              band = true;
            } else
            {
              const eventId = this.eventId ? this.eventId : this.registrationObj.eventSel.id;
              const item = this.registrationObj.events.filter((el) =>
              {
                return el.id == eventId;
              })[0];
              if (item) {
                this.nextStep(3);
                this.selectEvent(item);
            }
              return;
            }
            if (this.registrationObj.step > 2 && band)
            {
              this.refreshStep3(forLocalData);
            }
            if (this.registrationObj.step == 2)
            {
              this.$store.dispatch('setLoadingPageAction', false);
              this.$emit("changeLoadingStep", false);
            }
          }
        });
      } else {
        this.$emit("changeLoadingStep", false);
      }
    },
    async refreshStep3(forLocalData = false)
    {
      if (this.isSpectatorRegistration)
      {
        if (this.registrationObj.step == 3)
        {
        this.registrationObj.spectators.forEach((element) =>
        {
          element.selected = true;

        });
          this.registrationObj.spectatorsSel = [];
        }
      }
      LocalStorageService.setItem("registration_legacy", this.registrationObj);
      this.registrationObj.participants.forEach((element) =>
      {
        element.selected = false;
      });
      LocalStorageService.setItem("registration_legacy", this.registrationObj);
      const eventId = this.registrationObj.eventSel.id;
      const item = this.registrationObj.events.filter((el) =>
      {
        return el.id == eventId;
      })[0];
      if (item)
      {
        this.selectEvent(item, true, forLocalData);
      } else
      {
        const response = await RegistrationService.getEvent(eventId, this.userStore.id);
        if (response.data.success && response.data.message && !response.data.message.displayRegistrationFlag)
        {
          this.registrationObj.eventSel.type = "close";
        }
        this.refreshParticipants();
        this.$store.dispatch('setLoadingPageAction', false);
        this.$emit("changeLoadingStep", false);
      }
    },
    async selectEvent(item, bandRefreshStep3 = false, forLocalData = false)
    {
      await RegistrationService.verifyRegistrationDate(item.id).then(resp =>
      {
        if (resp.data.success)
        {
          if (item.registrationOpen != resp.data.message.registrationOpen || item.registrationClose != resp.data.message.registrationClose)
          {
            let date1 = moment();
            let date2 = moment(resp.data.message.registrationOpen).tz('America/New_York', true);
            let date3 = moment(resp.data.message.registrationClose).tz('America/New_York', true);
            let tz = moment.tz.guess();

            date2 = date2.clone().tz(tz);
            date3 = date3.clone().tz(tz);

            item.regOpen = date2.format("YYYY-MM-DD HH:mm:ss");
            item.regClose = date3.format("YYYY-MM-DD HH:mm:ss");
            item.nowDate = date1.format("YYYY-MM-DD HH:mm:ss");

            item.registrationOpen = item.regOpen;
            item.registrationClose = item.regClose;

            if (date2 > date1)
            {
              item.type = 'soon'
            } else if (date2 <= date1 && date3 >= date1)
            {
              item.type = 'now';
            } else if (date2 < date1 && date3 < date1)
            {
              item.type = 'close';
            }

            if (item.type != 'now')
            {
              this.updateLoad({ value: false, item });
            }
          }
        }
      });
      if (item.type == 'close')
      {
        this.snackbar = true;
        this.msg_snackbar = this.$t("registerEvent.event_closed");
        this.color_snackbar = 'error';
      }
      if (item.isSpectatorRegistration)
      {
        this.registrationObj.eventSel = item;
        this.registrationType = this.registrationObj.eventSel.registrationType;
        await RegistrationService.verifyValidateSpectators({ eventId: item.id }).then(resp =>
        {
          if (resp.data.success)
          {
            const spectators = resp.data.message.map((el) =>
            {
              const spectator = this.registrationObj.spectators.find((el1) => { return el1.userId == el.userId});
              return {
                ...el,
                selected: this.registrationObj.step <= 3 ? true : (spectator ? spectator.selected : true),
                colorEventWaiver: el.eventWaiver == 'NotSigned' || el.eventWaiver == 'Rejected'
              };
            });
            this.registrationObj.spectators = spectators;
            this.updateSpectators();
            if (this.registrationObj.step <= 3)
            {
              this.nextStep(3);
            } else
            {
              this.validateSpectators(forLocalData);
            }
          } else {
            this.snackbar = true;
            this.msg_snackbar = this.$t("registerEvent.event_not_spectator");
            this.color_snackbar = 'error';
          }
        });
        this.$store.dispatch('setLoadingPageAction', false);
        this.$emit("changeLoadingStep", false);
        this.updateLoad({ value: false, item: this.registrationObj.eventSel });
      } else
      {
        this.selectEventParticipant(item, bandRefreshStep3);
      }
    },
    refreshParticipants()
    {
      const link_back_ewc = LocalStorageService.getItem("link_back_event_waiver_create");
      const previusParticipants = LocalStorageService.getItem("previus_participants");
      this.linkBackEwc = link_back_ewc;
      LocalStorageService.removeItem("link_back_event_waiver_create");
      this.previusParticipants = previusParticipants;
      if (link_back_ewc == 'EventWaiverCreate')
      { 
        previusParticipants.forEach((el) =>
        {
          if (el.selected)
          {
            this.registrationObj.participants.forEach((e, i) =>
            {
              if (e.userId == el.userId)
              {
                this.registrationObj.participants[i].selected = true;
              }
            });
          }
        });
      }
    },
    eventHasPossibleReservation(item)
    {
      return Number(item.isReserved || 0) > 0 || Number(item.isReservedNum || 0) > 0;
    },
    participantHasReservation(participant)
    {
      return participant && participant.status == 'Reserved' && participant.isReserved != null;
    },
    isRegistrationTraceEnabled()
    {
      return window.location.href.indexOf('traceRegistration=1') >= 0 ||
        (window.localStorage && window.localStorage.getItem('trace_registration_legacy') == '1');
    },
    registrationTrace(label, payload = {})
    {
      if (!this.isRegistrationTraceEnabled())
      {
        return;
      }
      let snapshot = payload;
      try
      {
        snapshot = JSON.parse(JSON.stringify(payload));
      } catch (e)
      {
        snapshot = { error: 'trace_payload_not_serializable' };
      }
      window.__registrationLegacyTrace = window.__registrationLegacyTrace || [];
      window.__registrationLegacyTrace.push({
        at: new Date().toISOString(),
        label,
        payload: snapshot
      });
      // eslint-disable-next-line no-console
      console.info('[registration-legacy]', label, snapshot);
    },
    async selectEventParticipant(item, bandRefreshStep3 = false)
    {
      
      if (!bandRefreshStep3 && !this.eventHasPossibleReservation(item))
      {
        let valid = false;
        await RegistrationService.checkAvailability(item.id, { usersId: [] }).then(resp =>
        {
          if (resp.data.success)
          {
            valid = resp.data.message.valid;
          }
        });
        if (!valid)
        {
          this.color_snackbar = "error";
          this.msg_snackbar = this.$t("registerEvent.event_full");
          this.snackbar = true;
          this.registrationObj.events.forEach((el) =>
          {
            el.loading = false;
            if (item.id == el.id)
            {
              el.disabled = true;
            } else
            {
              el.disabled = false;
            }
          });
          return;
        }
      }

      var usersId = [];
      this.isMembership = item.validMembership;
      for (var i = 0; i < this.registrationObj.participants.length; i++)
      {
        usersId[i] = this.registrationObj.participants[i].userId;
      }

      let data = {};
      data.usersId = usersId;
      data.eventId = item.id;
      let _participants = this.registrationObj.participants;

      await RegistrationService.validationUsers(data).then(resp =>
      {
        if (resp.data.success == 1)
        {
          if (resp.data.message.length > 0)
          {
            resp.data.message.forEach(x =>
            {
              _participants.forEach(y =>
              {
                if (y.userId == x.userId)
                {
                  y.disabled = true;
                  y.selected = false;
                }
              });
            });
          }
        }
      });

      await RegistrationService.verifyStatus(data).then(resp =>
      {
        if (resp.data.success == 1)
        {
          if (resp.data.message.length > 0)
          {
            resp.data.message.forEach(x =>
            {
              _participants.forEach(y =>
              {
                if (y.userId == x.userId)
                {
                  y.disabled = false;
                  y.disabledLimit = false;
                  y.status = "";
                  y.statusColor = "";
                  y.isReserved = x.isReserved;
                  if (x.isReserved != null && (x.status == 'canceled' || x.status == 'failed' ||
                    x.status == 'imported' || x.status == 'inPayment' || x.status == 'paymentPending' ||
                    x.status == 'unconfirmed'))
                  {
                    y.status = 'Reserved';
                  } else if (x.status == 'added' || x.status == 'imported' || x.status == 'completed' || x.status == 'completing')
                  {
                    y.status = 'Already Registered';

                    y.statusColor = 'red';
                    y.disabled = true;
                    //only disable if multireg is off
                    if (x.isMultiReg == 1)
                    {
                      y.statusColor = '';
                      y.disabled = false;
                    }

                    y.selected = false;
                  } else
                  {
                    y.status = x.status;
                  }
                }
              });
            });
          }
        }
      });

      await RegistrationService.verifyEventWaiver(data).then(resp =>
      {
        if (resp.data.success == 1)
        {
          if (resp.data.message && resp.data.message.length > 0)
          {
            _participants = _participants.map((x) =>
            {
              let findPart = resp.data.message.find((y) => y.userId == x.userId);
              return {
                ...x,
                eventWaiver: findPart ? (findPart.status ? findPart.status : "") : "",
                eventWaiverCode: findPart ? findPart.status : undefined,
                colorEventWaiver: findPart ? (findPart.status == 'NotSigned' || findPart.status == 'Rejected') : undefined,
                eventWaiverId: findPart ? ((findPart.eventWaiverId || findPart.eventWaiverId == null) ? findPart.eventWaiverId : undefined) : undefined
              }
            });
          } else
          {
            _participants = _participants.map((x) =>
            {
              return {
                ...x,
                eventWaiver: "",
                eventWaiverCode: undefined,
                colorEventWaiver: undefined,
                eventWaiverId: undefined
              }
            });
          }
        }
      });

      await RegistrationService.checkEventMembership(data).then(async resp =>
      {
        if (resp.data.success == 1)
        {
          if (resp.data.message && resp.data.message.length > 0)
          {
            resp.data.message.forEach(x =>
            {
              _participants.forEach(async y =>
              {
                if (y.userId == x.userId)
                {
                  y.membership = "";
                  y.membershipColor = false;
                  y.waivers = "";
                  y.waiversColor = false;
                  y.waiverSigned = false;
                  y.classes = "";
                  y.classesColor = false;

                  if (x.result == 'invalid')
                  {
                    y.membership = 'membership_required';
                    y.membershipColor = true;
                  } else
                  {
                    y.membership = 'valid_member';

                    if (x.result == 'waivers')
                    {
                      y.requiresRelatedOrgWaiver = !!x.requiresRelatedOrgWaiver;
                      y.missingForcedOrgWaivers = x.missingForcedOrgWaivers || [];
                      y.waiverSigned = false;
                      if (y.requiresRelatedOrgWaiver && y.missingForcedOrgWaivers.length > 0) {
                        const orgNames = y.missingForcedOrgWaivers.map(o => o.organizationName).filter(Boolean).join(', ');
                        y.waivers = orgNames
                          ? this.$tc('registerEvent.waiver_signature_required_related_org', { orgNames })
                          : this.$t('registerEvent.waiver_signature_required');
                      } else {
                        y.waivers = this.$t('registerEvent.waiver_signature_required');
                      }
                      y.disabled = true;
                      y.selected = false;
                      y.waiversColor = true;
                    } else if (x.result == 'noclass')
                    {
                      if (x.hasWaiversToSign) {
                        y.requiresRelatedOrgWaiver = !!x.requiresRelatedOrgWaiver;
                        y.missingForcedOrgWaivers = x.missingForcedOrgWaivers || [];
                        y.waiverSigned = false;
                        y.waivers = this.$t('registerEvent.waiver_signature_required');
                        y.waiversColor = true;
                      } else {
                        y.waiverSigned = true;
                        y.waivers = this.$t('registerEvent.waiver_signed');
                      }
                      y.classes = this.$t('registerEvent.no_class_available');
                      y.classesColor = true;
                    } else if (x.result == 'valid')
                    {
                      y.waiverSigned = true;
                      y.waivers = this.$t('registerEvent.waiver_signed');
                      let data = {};
                      data.userId = x.userId;
                      data.eventId = item.id;

                      var hasWaiversToSignForEvent = await RegistrationService.hasWaiversToSignForEvent(data);
                      var getEventRegistrationClasses = await RegistrationService.getEventRegistrationClasses(data);

                      if (hasWaiversToSignForEvent.data.success == 1 && getEventRegistrationClasses.data.success == 1)
                      {
                        hasWaiversToSignForEvent = hasWaiversToSignForEvent.data.message;
                        const regClassesPayload = getEventRegistrationClasses.data.message;
                        const regClasses = Array.isArray(regClassesPayload) ? regClassesPayload : (regClassesPayload?.classes || []);
                        if (regClassesPayload && !Array.isArray(regClassesPayload)) {
                          this.registrationObj.eventOrganizations = regClassesPayload.eventOrganizations || [];
                        }
                        if ((hasWaiversToSignForEvent || regClasses.length == 0))
                        {
                          y.classes = this.$t('registerEvent.no_more_class_available');
                          y.classesColor = true;
                        }
                      }
                    }
                  }
                }
              });
            });
          }
        }
      });

      if (this.isMembership) {
        try {
          const listPayload = { usersId, eventId: item.id };
          const orgId = Number(item.organizationId || item.fkOrganizationId || item.organizationID || 0);
          if (orgId > 0) {
            listPayload.defaultOrganizationId = orgId;
          }
          const listResp = await MembershipWaiverService.getMembershipWaiversList(listPayload);
          const listRows = Array.isArray(listResp?.data?.message) ? listResp.data.message : [];
          if (listRows.length > 0) {
            const pendingUsers = new Set();
            listRows.forEach(row => {
              const isRequired = Number(row.required) === 1 || Number(row.qtSignReq) >= 1 || Number(row.signaturesRequired) >= 1;
              if (!isRequired) {
                return;
              }
              // Multi-signature rows expose signaturesRequired/signaturesSigned/allSignaturesComplete.
              // Treat the waiver as satisfied only when ALL required signatures are collected.
              let isComplete;
              if (typeof row.allSignaturesComplete !== 'undefined') {
                isComplete = Boolean(row.allSignaturesComplete);
              } else if (Number(row.signaturesRequired) > 0) {
                isComplete = Number(row.signaturesSigned || 0) >= Number(row.signaturesRequired);
              } else {
                const statusRaw = (row.waiverStatus || row.status || '').toString().trim().toLowerCase();
                isComplete = statusRaw === 'signed' || statusRaw === '2' || statusRaw === '4';
              }
              if (!isComplete) {
                pendingUsers.add(Number(row.userId));
              }
            });
            if (pendingUsers.size > 0) {
              _participants.forEach(y => {
                if (pendingUsers.has(Number(y.userId)) && y.waiverSigned) {
                  y.waiverSigned = false;
                  y.waiversColor = true;
                  y.waivers = this.$t('registerEvent.waiver_signature_required');
                }
              });
            }
          }
        } catch (e) {
          // Waiver list verification failed; keep checkEventMembership state
        }
      }

      await AccountStatusService.getMultiple(data).then(resp =>
      {
          if (resp.data.success != 1 || !resp.data.message || resp.data.message.length == 0)
          {
            return false;
          }

          resp.data.message.forEach(messageItem =>
          {
            const _part = _participants.find(p => p.userId == messageItem.userId);
            if(_part)
            {
              _part.emergencyContact = messageItem.emergencyContactsCount > 0 ? 1 : 0; 
              if(_part.birthday && typeof _part.birthday === 'string') {
                _part.birthdayString = _part.birthday.slice();
              }
              _part.birthday = messageItem.birthday ? 1 : 0;

              _part.disabled = (_part.emergencyContact == 0 || _part.birthday == 0) ? true : false;
              _part.selected = false;
            }
          });
      });

      this.registrationObj.participants = _participants;
      this.registrationObj.eventSel = item;
      this.registrationType = this.registrationObj.eventSel.registrationType;
      this.rows = [];
      LocalStorageService.setItem("registrationType_legacy", this.registrationType);

      if (!bandRefreshStep3)
      {
        if (this.registrationType == 1)
        {
          let selectRow = null;

          if (this.registrationObj.eventSel.rowCount == 0)
          {
            this.registrationObj.eventSel.rowCount = 1;
          }
          var numRows = Math.ceil(this.registrationObj.eventSel.maxRegistrants / this.registrationObj.eventSel.rowCount);

          selectRow = { id: -1, text: "Please Select" };
          this.rows.push(selectRow);

          if (this.registrationObj.eventSel.rowLimit != "" &&
            this.registrationObj.eventSel.rowLimit != 0 &&
            this.registrationObj.eventSel.rowLimit != null)
          {

            this.registrationObj.eventSel.rowLimit = this.registrationObj.eventSel.rowLimit.replace(/ /g, "");
            var limits = this.registrationObj.eventSel.rowLimit.split(",");

            for (var a = 0; a < limits.length; a++)
            {
              var rng = limits[a].split("-");
              for (var b = parseInt(rng[0]); b <= parseInt(rng[1]); b++)
              {

                selectRow = { id: b, text: "Row " + b };
                this.rows.push(selectRow);
              }
            }
          } else
          {
            //add all rows
            for (var c = 1; c <= numRows; c++)
            {
              selectRow = { id: c, text: "Row " + c };
              this.rows.push(selectRow);
            }
          }

          LocalStorageService.setItem("rows_legacy", this.rows);
        }
        this.returnSummary = this.registrationObj.eventSel.registrationType != 1 ? true : false;
        let parts = this.registrationObj.participants.filter((el) =>
        {
          return el.selected;
        });
        if (parts.length >= this.registrationObj.eventSel.leftOpen)
        {
          this.registrationObj.participants.forEach((element, i) =>
          {
            if (!element.selected)
            {
              this.registrationObj.participants[i].disabledLimit = true;
            }
          });
        }
      } else
      {
        LocalStorageService.setItem("registration_legacy", this.registrationObj);
      }
      if (this.registrationObj.step > 2)
      {
        this.$store.dispatch('setLoadingPageAction', false);
        this.$emit("changeLoadingStep", false);
        this.loadingToStepParticipant = false;
        this.refreshParticipants();
      }
      
      this.updateLoad({ value: false, item: this.registrationObj.eventSel });
      this.disabledStep3 = false;
      let newStep = this.registrationObj.step;
      
      if(!bandRefreshStep3 && newStep < this.stepperSteps.length) {
        newStep++;
      }
      let timeOut = 0;
      if(bandRefreshStep3) timeOut = 500;
      setTimeout(() => {
      this.nextStep(newStep);
      },timeOut);
    },
    nextStep(n)
    {
      this.registrationObj.step = n;
      if(n == 3) {
        const stepParticipantRef = this.$refs.stepParticipantRef;
        if (stepParticipantRef && stepParticipantRef[0]) {
          stepParticipantRef[0].getOrganizations();
        }
      }
      this.registrationObj.preferredRow = this.row;
      LocalStorageService.setItem("registration_legacy", this.registrationObj);
      var elem2 = document.getElementById("scrolling-techniques-7");
      elem2.scrollTop = 0;
    },
    async validateRiders()
    {
      let _selected = this.registrationObj.participants.filter(x => x.selected);
      const usersIdAux = _selected.map((el) =>
      {
        return el.userId;
      });

      let valid = false;
      let error = "";
      const stepParticipantRef = this.$refs.stepParticipantRef[0];

      await RegistrationService.checkAvailability(this.registrationObj.eventSel.id, { usersId: usersIdAux }).then(resp =>
      {
        if (resp.data.success)
        {
          valid = resp.data.message.valid;
          error = resp.data.message.message;
        }
      });

      const selectedOpenSlotParticipants = _selected.filter(participant => !this.participantHasReservation(participant)).length;
      const openSlotCapacity = Math.max(0, Number(this.registrationObj.eventSel.leftOpen || 0));
      this.registrationTrace('validateRiders.capacityGate', {
        eventId: this.registrationObj.eventSel.id,
        leftOpen: this.registrationObj.eventSel.leftOpen,
        openSlotCapacity,
        isReservedNum: this.registrationObj.eventSel.isReservedNum,
        usersIdAux,
        checkAvailability: { valid, error },
        selectedOpenSlotParticipants,
        selected: _selected.map(participant => ({
          userId: participant.userId,
          status: participant.status,
          isReserved: participant.isReserved,
          hasReservation: this.participantHasReservation(participant)
        }))
      });

      if (!valid)
      {
        this.color_snackbar = "error";
        if (this.registrationObj.eventSel.leftOpen <= 0)
        {
          this.msg_snackbar = this.$t("registerEvent.event_full");
          this.disabledStep3 = true;
        } else
        {
          if (error != "")
          {
            if (error == "error_left_open")
              this.msg_snackbar = this.$t("registerEvent.no_more_places_finish", { leftOpen: this.registrationObj.eventSel.leftOpen });
            else if (error == "error_limit_row")
              this.msg_snackbar = this.$t("registerEvent.error_only_row_participants", { rowCount: this.registrationObj.eventSel.rowCount });
            else if (error == "error_no_buddy_registration")
            {
              this.msg_snackbar = this.$t("registerEvent.error_no_buddy_registration");
            }
            else
              this.msg_snackbar = this.$t("common.error_general");
          } else
            this.msg_snackbar = this.$t("common.error_general");
        }
        this.snackbar = true;
        
        if (stepParticipantRef)
        {
          stepParticipantRef.changeTab(0);
          stepParticipantRef.setLoading(false);
        }
        return;
      }

      if (_selected.length == 0)
      {
        this.color_snackbar = "error"
        this.msg_snackbar = this.$t("registerEvent.error_selected_one");
        this.snackbar = true;
        if (stepParticipantRef) 
        {
          stepParticipantRef.setLoading(false);
          stepParticipantRef.changeTab(0);
        }
      } else if (selectedOpenSlotParticipants > openSlotCapacity)
      {
        this.color_snackbar = "error";
        this.msg_snackbar = this.$t("registerEvent.error_exceeded_places");
        this.snackbar = true;
        if (stepParticipantRef)
        {
          stepParticipantRef.setLoading(false);
          stepParticipantRef.changeTab(0);
        } 
      } else if (_selected.length > 1 && !this.registrationObj.eventSel.isBuddyRegistrationAllowed)
      {
        this.color_snackbar = "error";
        this.msg_snackbar = this.$t("registerEvent.error_only_selected_one");
        this.snackbar = true;
        if (stepParticipantRef)
        {
          stepParticipantRef.setLoading(false);
          stepParticipantRef.changeTab(0);
        } 
      } else
      {
        const ageBlockedNames = [];
        const noClassNames = [];

        let allClasses = [];
        const refResp = await RegistrationService.getEventRegistrationClasses({
          userId: this.registrationObj.userId,
          eventId: this.registrationObj.eventSel.id,
        });
        if (refResp?.data?.success) {
          const rp = refResp.data.message;
          if (Array.isArray(rp)) {
            allClasses = rp;
          } else if (rp && typeof rp === "object") {
            allClasses = Array.isArray(rp.classes) ? rp.classes : [];
          }
        }
        for (const participant of _selected) {
          const resp = await RegistrationService.getEventRegistrationClasses({
            userId: participant.userId,
            eventId: this.registrationObj.eventSel.id,
          });
          if (resp?.data?.success) {
            const payload = resp.data.message;
            // Parse the getEventRegistrationClasses response.
            // The API returns different shapes depending on context:
            //   1. Array of class objects           -> direct class list
            //   2. { notRegisteredPart: true }       -> multi-reg event, member has
            //      classes available but isn't registered yet
            //   3. { classes: { notRegisteredPart: true } } -> same as #2, nested
            //   4. { classes: [...] }                -> class list inside wrapper
            // Previously shapes #2 and #3 were incorrectly treated as "no classes
            // available" because the notRegisteredPart flag was not checked,
            // causing a false "does not have any classes" error for valid members.
            let classes = [];
            let hasAvailableClasses = false;
            if (Array.isArray(payload)) {
              classes = payload;
            } else if (payload && typeof payload === "object") {
              if (payload.notRegisteredPart) {
                hasAvailableClasses = true;
              } else {
                const raw = payload.classes;
                if (raw && typeof raw === "object" && !Array.isArray(raw) && raw.notRegisteredPart) {
                  hasAvailableClasses = true;
                } else if (Array.isArray(raw)) {
                  classes = raw;
                }
              }
            }
            if (classes.length === 0 && !hasAvailableClasses) {
              const name = `${participant.fName || ""} ${participant.lName || ""}`.trim();
              const bday = participant.birthdayString || (typeof participant.birthday === 'string' ? participant.birthday : null);
              if (bday && this.isBlockedByAge(bday, allClasses)) {
                ageBlockedNames.push(name);
              } else {
                noClassNames.push(name);
              }
            }
          }
        }

        if (ageBlockedNames.length > 0) {
          this.msg_snackbar = this.$t("registerEvent.age_restriction_no_classes", {
            names: ageBlockedNames.join(", "),
          });
          this.color_snackbar = "error";
          this.snackbar = true;
          if (stepParticipantRef) {
            stepParticipantRef.setLoading(false);
            stepParticipantRef.changeTab(0);
          }
          return;
        }

        if (noClassNames.length > 0) {
          this.msg_snackbar = this.$t("registerEvent.no_eligible_classes_for_riders", {
            names: noClassNames.join(", "),
          });
          this.color_snackbar = "error";
          this.snackbar = true;
          if (stepParticipantRef) {
            stepParticipantRef.setLoading(false);
            stepParticipantRef.changeTab(0);
          }
          return;
        }

        let _max = this.registrationObj.eventSel.isMultiReg == 0 ? 1 : 9999;
        this.registrationObj.partsSel = _selected.map((x) =>
        {
          return {
            userId: x.userId,
            fName: x.fName,
            lName: x.lName,
            maxRegistrations: _max,
            isAddClass: false,
            showError: '',
            disabledButton: true,
            organization: false,
            organizations: [],
            items: []
          };
        });
        var usersId = [];
        var eventSelfOrg;

        let data_ = {};
        data_.eventId = this.registrationObj.eventSel.id;
        data_.langageCode = this.$i18n.locale;

        let organizations = -1;

        for (var i = 0; i < this.registrationObj.partsSel.length; i++)
        {

          usersId[i] = this.registrationObj.partsSel[i].userId;
          data_.userId = this.registrationObj.partsSel[i].userId;

          eventSelfOrg = await RegistrationService.getEventSelfOrg(data_);

          if (eventSelfOrg.data.success == 1)
          {
            if (eventSelfOrg.data.message.length > 0)
            {
              eventSelfOrg.data.message.forEach(x =>
              {
                this.registrationObj.partsSel.forEach(y =>
                {

                  if (x.userId == y.userId)
                  {
                    y.organization = true;
                    y.organizations.push({
                      disabled: (x.memberId.length > 0) ? true : false,
                      id: x.id,
                      organization: x.organization,
                      isRequestMemberInfo: x.isRequestMemberInfo,
                      eventId: x.eventId,
                      organizationId: x.organizationId,
                      membersAddInfo: x.membersAddInfo,
                      fkeventOrganizationId: x.fkeventOrganizationId,
                      fkLanguageCodeId: x.fkLanguageCodeId,
                      languageCode: x.languageCode,
                      languageName: x.languageName,
                      OrganizationTableId: x.OrganizationTableId,
                      memberId: x.memberId
                    });
                    organizations = 1;
                    this.rowPreferred_ = "4.2";
                    this.organization_ = "4.1";
                  }
                });
              });
            }
          }

        }
        this.organizations = organizations;

        if (this.organizations != 1)
        {
          this.rowPreferred_ = "4.1";
          this.organization_ = "";
        }
        LocalStorageService.setItem("organizations_legacy", this.organizations);

        let data = {};
        data.usersId = usersId;
        this.createEventRegistrationLegacy();
        stepParticipantRef.setLoading(false);
      }
    },
    async validateOrganizations()
    {
      let usersId = [];
      let eventSelfOrg;
      let data_ = {};
      data_.eventId = this.registrationObj.eventSel.id;
      data_.langageCode = this.$i18n.locale;
      let organizations = -1;

      for (var i = 0; i < this.registrationObj.participants.length; i++)
      {

        usersId[i] = this.registrationObj.participants[i].userId;
        data_.userId = this.registrationObj.participants[i].userId;

        eventSelfOrg = await RegistrationService.getEventSelfOrg(data_);
        if (eventSelfOrg.data.success == 1)
        {
          if (eventSelfOrg.data.message.length > 0)
          {
            eventSelfOrg.data.message.forEach(x =>
            {
              this.registrationObj.participants.forEach(y =>
              {

                if (x.userId == y.userId)
                {
                  y.organization = true;
                  if (Array.isArray(y.organizations))
                  {
                    y.organizations.push({
                      disabled: (x.memberId.length > 0) ? true : false,
                      id: x.id,
                      organization: x.organization,
                      isRequestMemberInfo: x.isRequestMemberInfo,
                      eventId: x.eventId,
                      organizationId: x.organizationId,
                      membersAddInfo: x.membersAddInfo,
                      fkeventOrganizationId: x.fkeventOrganizationId,
                      fkLanguageCodeId: x.fkLanguageCodeId,
                      languageCode: x.languageCode,
                      languageName: x.languageName,
                      OrganizationTableId: x.OrganizationTableId,
                      memberId: x.memberId
                    });
                  }
                  organizations = 1;
                  this.rowPreferred_ = "4.2";
                  this.organization_ = "4.1";
                }
              });
            });
          }
        }
      }
      this.organizations = organizations;

      if (this.organizations != 1)
      {
        this.rowPreferred_ = "4.1";
        this.organization_ = "";
      }
    },
    clearEventRegistration()
    {
      LocalStorageService.removeItem("registration_legacy");
      LocalStorageService.removeItem("registrationType_legacy");
      LocalStorageService.removeItem("organizations_legacy");
      LocalStorageService.setItem("registration_legacy", this.registrationObj);
    },
    createEventRegistrationLegacy()
    {
      let band = false;
      let msg = "";
      let notValid = [];

      if (this.registrationObj.eventSel.validMembership)
      {
        notValid = this.registrationObj.partsSel.filter((el) =>
        {
          const find = this.registrationObj.participants.find((ele) =>
          {
            return (el.userId == ele.userId && ele.selected && ele.membership == "valid_member" && ele.classes == "" && (ele.eventWaiver == "Signed" || ele.eventWaiver == "") && ele.waivers == "");
          });
          return !find;
        });

        if (notValid.length == 0)
        {
          band = true
        }
      } else
      {
        notValid = this.registrationObj.partsSel.filter((el) =>
        {
          const find = this.registrationObj.participants.find((ele) =>
          {
            return (el.userId == ele.userId && ele.selected && (ele.eventWaiver == "" || ele.eventWaiver == "Signed") && ele.waivers == "");
          });
          return !find;
        });

        if (notValid.length == 0)
        {
          band = true
        }
      }
      let dataParticipant = [], bandp = true;
      this.registrationObj.partsSel.forEach((el) =>
      {
        dataParticipant.push(el.userId);
      });
      const datap = {
        eventId: this.registrationObj.eventSel.id,
        participants: dataParticipant,
      };
      RegistrationService.verifyValidateReserved(datap).then((response) =>
      {
        const reserved = Number(response.data.message || 0)
        const part = datap.participants.length - reserved;
        const reservedGateOpenSlotCapacity = Math.max(0, Number(this.registrationObj.eventSel.leftOpen || 0));
        this.registrationTrace('createEventRegistrationLegacy.reservedGate', {
          eventId: this.registrationObj.eventSel.id,
          participants: datap.participants,
          responseSuccess: response.data.success,
          reserved,
          part,
          leftOpen: this.registrationObj.eventSel.leftOpen,
          isReservedNum: this.registrationObj.eventSel.isReservedNum,
          reservedGateOpenSlotCapacity
        });

        if (band && this.registrationObj.eventSel.leftOpen <= 0)
        {
          bandp = response.data.success;
          band = response.data.success && part <= reservedGateOpenSlotCapacity;
          bandp = band;
        }

        if (band)
        {
          let registrationObjReq = {};
          registrationObjReq.spectatorsSel = this.registrationObj.spectatorsSel
          registrationObjReq.partsSel = this.registrationObj.partsSel
          registrationObjReq.practicesSel = this.registrationObj.practicesSel ? this.registrationObj.practicesSel.filter(reg => reg.status) : []
          const data = {
            eventId: this.registrationObj.eventSel.id,
            userId: this.registrationObj.userId,
            registration: registrationObjReq
          };
          RegistrationService.createEventRegistrationLegacy(data).then((response) =>
          {
            if (response.data.success)
            {
              this.registrationObj.step = 4;
              this.clearEventRegistration();
              window.location.href = `${this.$store.getters.env.get('VUE_APP_BASE')}eventRegistration?eId=${this.registrationObj.eventSel.id}`;
            } else
            {
              if (response.data.message == 'insert_failed')
              {
                this.color_snackbar = "error";
                this.msg_snackbar = this.$t("registerEvent.error_insert_failed");
                this.snackbar = true;
              } else{
                let _message = response.data.message;
                const membershipMessages = {
                  membership_required: "registerEvent.msg_valid_member",
                  membership_class_required: "registerEvent.msg_valid_classes",
                  waivers_required: "registerEvent.msg_valid_membership",
                  registration_completion_failed: "registerEvent.error_insert_failed",
                };
                const membershipCode = Array.isArray(_message) ? _message[0] : _message;
                if (membershipCode && Object.prototype.hasOwnProperty.call(membershipMessages, membershipCode)) {
                  this.color_snackbar = "error";
                  this.msg_snackbar = this.$t(membershipMessages[membershipCode]);
                  this.snackbar = true;
                } else if(_message == 'not_found_userId'){
                  this.color_snackbar = "error";
                  this.msg_snackbar = this.$t("registerEvent.not_found_userId");
                  this.snackbar = true;
                  this.$router.push({ name: 'Login' });
                }else{
                  if (
                    typeof _message == 'object' &&
                    Object.prototype.hasOwnProperty.call((_message || {}), 'registrantName') &&
                    Object.prototype.hasOwnProperty.call((_message || {}), 'userName')
                  )
                  {
                    this.color_snackbar = "error";
                    this.msg_snackbar = this.$t("registerEventLegacy.registration_in_progress", { registrantName: _message.registrantName, userName: _message.userName });
                    this.snackbar = true;
                  } else
                  {
                    this.color_snackbar = "error";
                    this.msg_snackbar = this.$t("common.error_general");
                    this.snackbar = true;
                  }
                }                
              }
              const stepParticipantRef = this.$refs.stepParticipantRef;
              if (stepParticipantRef) stepParticipantRef[0].changeTab(0);
            }
          });
        } else
        {
          
          if (!bandp)
          {
            this.color_snackbar = "error";
            this.msg_snackbar = this.$t("registerEvent.error_exceeded_places");
            this.snackbar = true;
          } else
          {
            msg = "";
            const errorFind = this.registrationObj.participants.find((ele) =>
            {              
              if (ele.classes != "") {
                msg = this.$t('registerEvent.msg_valid_classes');
              } else if (ele.eventWaiver != "" && ele.eventWaiver != "Signed") {
                msg = this.$t('registerEvent.msg_valid_event_waiver');
              } else if (ele.membership == 'membership_required') {
                msg = this.$t('registerEvent.msg_valid_member');
                //
              } else if (ele.waivers != "") {
                msg = this.$t('registerEvent.msg_valid_membership');
              }
              return ele.userId == notValid[0].userId;
            });
            msg = (errorFind && errorFind.classes != "") ? errorFind.classes : msg;
            this.color_snackbar = "error";
            this.msg_snackbar = msg;
            this.snackbar = true;
          }
          const stepParticipantRef = this.$refs.stepParticipantRef;
          if (stepParticipantRef) stepParticipantRef[0].changeTab(0);
        }
      });

    },
    loadOldSite()
    {
      const eventId = (this.registrationObj && this.registrationObj.eventSel) ? this.registrationObj.eventSel.id : null;

      if (eventId)
      {
        RegistrationService.getPromoter(eventId).then((resp) =>
        {
          if (resp.data.success)
          {
            const promoterId = resp.data.message;
            const item = this.registrationObj.promoters.filter((el) =>
            {
              return promoterId == el.userID;
            })[0];
            this.getEventsByPromoter(item, true);
          }
        });
        return true;
      }
      return false;
    },
    updateParticipants({ newValue, id })
    {
      if(!this.registrationObj.eventSel) return;

      const participants = this.registrationObj.participants;
      const participant = participants.find(p => p.userId === id);

      participants.forEach(p =>
      {
        if (!p.selected)
        {
          p.disabledLimit = false;
        }
      });

      this.updateParticipantSelectionStatus({participant, bSelected: newValue});
    },
    updateParticipantSelectionStatus({ participant, bSelected })
    {
      let selectedParticipants = this.registrationObj.participants.filter(p => p.selected);
      if (participant)
      {
        const participantUserId = Number(participant.userId);
        selectedParticipants = selectedParticipants.filter(p => Number(p.userId) !== participantUserId);
        if (bSelected)
        {
          selectedParticipants.push(participant);
        }
      }
      const selectedOpenSlotParticipants = selectedParticipants.filter(p => !this.participantHasReservation(p)).length;
      const participantHasReservation = this.participantHasReservation(participant);
      const eventSel = this.registrationObj.eventSel;
      const leftOpen = Number(eventSel.leftOpen || 0);
      const openSlotCapacity = Math.max(0, leftOpen);
      const rowCount = Number(eventSel.rowCount || 0);
      let bValid = true;

      this.registrationTrace('updateParticipantSelectionStatus.capacityGate', {
        bSelected,
        participant: participant ? {
          userId: participant.userId,
          status: participant.status,
          isReserved: participant.isReserved,
          hasReservation: participantHasReservation
        } : null,
        leftOpen,
        openSlotCapacity,
        selectedOpenSlotParticipants
      });

      if (bSelected && !participantHasReservation && selectedOpenSlotParticipants > openSlotCapacity)
      {
        if (!this.snackbar && bSelected)
        {
          this.color_snackbar = "error";
          this.msg_snackbar = this.$t("registerEvent.error_no_more_places");
          this.snackbar = true;
        }
        bValid = false;
      }
      else if (bSelected && !participantHasReservation && eventSel.registrationType == 1 && selectedOpenSlotParticipants > rowCount)
      {
        if (!this.snackbar && bSelected)
        {
          this.color_snackbar = "error";
          this.msg_snackbar = this.$t("registerEvent.error_only_row_participants", { rowCount: eventSel.rowCount });
          this.snackbar = true;
        }
        bValid = false;
      }


      if (!bSelected && bValid)
      {
        this.snackbar = false;
      }

      if(bValid)
      {
        this.$nextTick(() => {
          const participantIndex = this.registrationObj.participants.findIndex(p => p.userId === participant.userId);
          if (participantIndex >= 0) {
            Vue.set(this.registrationObj.participants[participantIndex], 'selected', bSelected);
          }
          this.updatedRegistrationObjInStorage();
        });
      } 

    },
    async updatedRegistrationObjInStorage(){
      await LocalStorageService.setItem("registration_legacy", this.registrationObj);
    },
    /** I will keep the next method there for further analisis */
    /*
    updateParticipants_old(data)
    {
      const { newValue, id } = data;
      let bandAuthorize = false;
      let parts = this.registrationObj.participants.filter((el) =>
      {

        if (el.selected && !el.managerAccount)
        {
          //bandAuthorize = true;
          //[8:24 PM]pm74: Personne a besoin d'etre accompte manager pour enregistrÃ© quelqu'un d'autre
        }

        return el.selected;

      });
      if (
        this.registrationObj.eventSel && Array.isArray(parts) &&
        (parts.length < this.registrationObj.eventSel.leftOpen &&
          (this.registrationObj.eventSel.registrationType != 1 ||
            (this.registrationObj.eventSel.registrationType == 1 && parts.length < this.registrationObj.eventSel.rowCount))) &&
        (this.registrationObj.eventSel.isBuddyRegistrationAllowed == 1 || (this.registrationObj.eventSel.isBuddyRegistrationAllowed == 0 && !bandAuthorize))
      ) 
      {
        //(this.registrationObj.eventSel.isBuddyRegistrationAllowed == 1 || (this.registrationObj.eventSel.isBuddyRegistrationAllowed == 0 && !bandAuthorize))
        // The validation bellow is useless because bandAuthorize is always equals to 0, then... it is aking for:
        // this.registrationObj.eventSel.isBuddyRegistrationAllowed == 1 || this.registrationObj.eventSel.isBuddyRegistrationAllowed == 0
        this.registrationObj.participants.forEach(element =>
        {
          if (!element.selected)
          {
            element.disabledLimit = false;
          }
        });
        this.registrationObj.participants.forEach((element, index) =>
        {
          if (element.userId == id)
          {
            this.registrationObj.participants[index].selected = newValue;
          }
        });
      } else
      {
        this.registrationObj.participants.forEach(element =>
        {
          if (!element.selected)
          {
            element.disabledLimit = true;
          }
        });
        
        if (bandAuthorize)
        {
          //This block of code will never run, bandAuthorize is always false
          this.color_snackbar = "error";
          this.msg_snackbar = this.$t("registerEvent.error_no_buddy_registration");
          this.snackbar = true;
        } else if (parts.length - this.registrationObj.eventSel.isReservedNum > this.registrationObj.eventSel.leftOpen)
        {
          this.color_snackbar = "error";
          this.msg_snackbar = this.$t("registerEvent.error_no_more_places");
          this.snackbar = true;
        } else if (this.registrationObj.eventSel.registrationType == 1 && parts.length > this.registrationObj.eventSel.rowCount)
        {
          this.color_snackbar = "error";
          this.msg_snackbar = this.$t("registerEvent.error_only_row_participants", { rowCount: this.registrationObj.eventSel.rowCount });
          this.snackbar = true;
        }
      }
      LocalStorageService.setItem("registration_legacy", this.registrationObj);
    },*/
    updateSpectators()
    {
      let spectsTotal = this.registrationObj.spectators.filter((el) =>
      {
        return el.selected;
      });
      let cont = 0;
      this.registrationObj.participantsSel = []
      this.registrationObj.participants.forEach((element) =>
      {
        spectsTotal.forEach((element1) =>
        {
          if (element.userId == element1.userId)
          {
            this.registrationObj.participantsSel[cont] = element
            cont++
          }
        });
      });

      let spects = this.registrationObj.spectators.filter((el) =>
      {
        return el.selected && el.status != 'completed';
      });
      this.registrationObj.spectatorsSel = spects;
      
      if(this.isPracticeRegistration) {
        const { participants: _participants, eventSel: { practices } } = this.registrationObj;
        _participants.forEach((part) => {
          practices.forEach((practice) => {
                this.updatePracticeParticipants({
                    practiceId: practice.id,
                    status: false,
                    userId: part.userId,
                    practicePrice: ''
                });
          });
        });
      }
      LocalStorageService.setItem("registration_legacy", this.registrationObj);
    },
    updateLoad({ value, item })
    {
      this.registrationObj.events.forEach((el) =>
      {
        if (item.id == el.id)
        {
          el.loading = value;
        } else
        {
          el.disabled = value;
        }
      });
    },
    alertNotValidate(msg)
    {
      this.color_snackbar = "error";
      this.msg_snackbar = msg;
      this.snackbar = true;
    },
    showAlert({ msg, color }) {
      this.color_snackbar = color;
      this.msg_snackbar = msg;
      this.snackbar = true;
    },
    orderPromoter(data)
    {
      let arrayData = [];
      let arrayFirst = [];
      data.forEach(resp =>
      {
        if (resp.promoterId == this.promoterId)
        {
          arrayFirst.push(resp);
        } else
        {
          arrayData.push(resp);
        }
      });
      this.registrationObj.promoters = arrayFirst.concat(arrayData);
    },
    breadCrumbStep1()
    {
      this.registrationObj.step = 1;
    },
    refreshHeader(item)
    {
      this.registrationObj.eventSel.registrationOpen = item.registrationOpen;
      this.registrationObj.eventSel.registrationClose = item.registrationClose;
    },
    validateSpectators(forLocalData = false, nextStep = false)
    {

      if (this.registrationObj.eventSel.isSpectatorRegistration)
      {
        let spects = this.registrationObj.spectators.filter((el) =>
        {
          return el.selected;
        });
        if (spects.length > 0)
        {
          let spectsNotSigned = spects.filter((el) =>
          {
            return el.eventWaiver == 'NotSigned' || el.eventWaiver == 'Not Signed' || el.eventWaiver == 'Rejected';
          });
          if (spectsNotSigned.length > 0 && this.registrationObj.step <= 3)
          {
            this.snackbar = true;
            this.msg_snackbar = this.$t("registerEvent.spectator_not_signed_error");
            this.color_snackbar = 'error';
            const stepSpectator = this.$refs.stepSpectatorRef;
            if (stepSpectator)
            {
              stepSpectator[0].changeTab(0);
            }
          } else
          {
            this.loadingToStepParticipant = true;
            this.selectEventParticipant(this.registrationObj.eventSel,forLocalData);
          }
        } else
        {
          if (!forLocalData && this.registrationObj.step == 3)
          {
            const stepSpectator = this.$refs.stepSpectatorRef;
            if (stepSpectator)
            {
              stepSpectator[0].dialogWarning = true;
            }
          } else if (forLocalData)
          {
            this.selectEventParticipant(this.registrationObj.eventSel);
          }
        }
      } else
      {
        this.selectEventParticipant(this.registrationObj.eventSel);
      }

      if(nextStep)
      {
        this.registrationObj.step += 1;
      }
    },
    validateSpectatorsWaiver()
    {
      this.snackbar = true;
      this.msg_snackbar = this.$t("registerEvent.spectator_signed_error");
      this.color_snackbar = 'error';
    },
    loadUserStoreInit(user = false)
    {
      if (user)
      {
        this.userId = user.id;
        this.registrationObj.userId = this.userId;
        this.birthdayCurrent = user.birthday;
        this.userAge = this.calculateAge(user.birthday);
        this.loading = true;
        if (this.age18)
        {
          if(this.defaultRegistration && Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length > 0) {
            this.$store.dispatch('getPromoterAction', this.defaultPromoterId).finally(() => {
              this.getLocalData();
            });
          } else {
            this.getLocalData();
          }
        } else
        {
          this.$store.dispatch('setLoadingPageAction', false);
          this.$emit("changeLoadingStep", false);
        }
        this.bandLoadUserStore = true;
      }
    },
    calculateAge(birthday) {
      const today = new Date();
      const birthDate = new Date(birthday);
      
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      
      return age;
    },
    isBlockedByAge(birthdayStr, classes) {
      if (!classes || classes.length === 0) return false;
      if (!birthdayStr) return false;
      const age = this.calculateAge(birthdayStr);
      return !classes.some((cls) => {
        const min = parseInt(cls.minAge) || 0;
        const max = parseInt(cls.maxAge) || 0;
        if (min <= 0 && max <= 0) return true;
        return (min <= 0 || age >= min) && (max <= 0 || age <= max);
      });
    },
    confirmNextStepParticipant()
    {
      this.loadingToStepParticipant = true;
      this.selectEventParticipant(this.registrationObj.eventSel);
    },
    refreshEventWaiverStatus(index, retriesLeft = 8)
    {
      if (index == 'participants')
      {
        const participants = this.registrationObj.participants || [];
        const usersId = participants.map((p) => p.userId);
        const eventId = this.registrationObj.eventSel.id;
        const data = { usersId, eventId };

        const previousSnapshot = participants.map((p) => ({
          userId: p.userId,
          eventWaiver: p.eventWaiver,
          eventWaiverCode: p.eventWaiverCode,
          eventWaiverId: p.eventWaiverId,
          membership: p.membership,
          waivers: p.waivers
        }));

        Promise.all([
          RegistrationService.verifyEventWaiver(data),
          RegistrationService.checkEventMembership(data)
        ]).then(([waiverResp, membershipResp]) =>
        {
          if (waiverResp.data.success == 1 && waiverResp.data.message && waiverResp.data.message.length > 0)
          {
            participants.forEach((p) =>
            {
              const found = waiverResp.data.message.find((w) => w.userId == p.userId);
              const newStatus = found ? (found.status || "") : "";
              const newCode = found ? found.status : undefined;
              const newColor = found ? (found.status == 'NotSigned' || found.status == 'Rejected') : undefined;
              const newWaiverId = found ? ((found.eventWaiverId || found.eventWaiverId == null) ? found.eventWaiverId : undefined) : undefined;

              if (p.eventWaiver !== newStatus) this.$set(p, 'eventWaiver', newStatus);
              if (p.eventWaiverCode !== newCode) this.$set(p, 'eventWaiverCode', newCode);
              if (p.colorEventWaiver !== newColor) this.$set(p, 'colorEventWaiver', newColor);
              if (p.eventWaiverId !== newWaiverId) this.$set(p, 'eventWaiverId', newWaiverId);
            });
          }

          if (membershipResp.data.success == 1 && membershipResp.data.message && membershipResp.data.message.length > 0)
          {
            membershipResp.data.message.forEach((x) =>
            {
              const p = participants.find((y) => y.userId == x.userId);
              if (!p) return;

              if (x.result == 'invalid')
              {
                this.$set(p, 'membership', 'membership_required');
                this.$set(p, 'membershipColor', true);
              } else
              {
                this.$set(p, 'membership', 'valid_member');
                this.$set(p, 'membershipColor', false);

                if (x.result == 'waivers')
                {
                  const waiverText = (x.requiresRelatedOrgWaiver && x.missingForcedOrgWaivers?.length > 0)
                    ? (x.missingForcedOrgWaivers.map(o => o.organizationName).filter(Boolean).join(', ')
                        ? this.$tc('registerEvent.waiver_signature_required_related_org', { orgNames: x.missingForcedOrgWaivers.map(o => o.organizationName).filter(Boolean).join(', ') })
                        : this.$t('registerEvent.waiver_signature_required'))
                    : this.$t('registerEvent.waiver_signature_required');
                  this.$set(p, 'waivers', waiverText);
                  this.$set(p, 'waiversColor', true);
                  this.$set(p, 'requiresRelatedOrgWaiver', !!x.requiresRelatedOrgWaiver);
                  this.$set(p, 'missingForcedOrgWaivers', x.missingForcedOrgWaivers || []);
                } else
                {
                  this.$set(p, 'waivers', '');
                  this.$set(p, 'waiversColor', false);
                }
              }
            });
          }

          const changed = participants.some((p) =>
          {
            const prev = previousSnapshot.find((s) => s.userId == p.userId);
            if (!prev) return false;
            return prev.eventWaiver !== p.eventWaiver ||
              prev.eventWaiverCode !== p.eventWaiverCode ||
              prev.eventWaiverId !== p.eventWaiverId ||
              prev.membership !== p.membership ||
              prev.waivers !== p.waivers;
          });

          if (!changed && retriesLeft > 0) {
            setTimeout(() => this.refreshEventWaiverStatus(index, retriesLeft - 1), 1500);
          }
        });
        return;
      }

      let data = {};
      data.usersId = (this.registrationObj[index] || []).map((el) => el.userId);
      data.eventId = this.registrationObj.eventSel.id;
      const previousSpectators = (this.registrationObj.spectators || []).map((spectator) => ({
        userId: spectator.userId,
        eventWaiver: spectator.eventWaiver,
        eventWaiverCode: spectator.eventWaiverCode,
        eventWaiverId: spectator.eventWaiverId
      }));

      RegistrationService.verifyValidateSpectators({ eventId: this.registrationObj.eventSel.id }).then(resp =>
      {
        if (resp.data.success)
        {
          let spectators = [];
          this.registrationObj.spectators.forEach((el) =>
          {
            resp.data.message.map((el1) =>
            {
              if (el.userId == el1.userId)
              {
                spectators.push({
                  ...el1,
                  selected: el.selected,
                  colorEventWaiver: el1.eventWaiver == 'NotSigned' || el1.eventWaiver == 'Rejected'
                });
              }
            });
          });
          this.registrationObj.spectators = spectators;
          this.registrationObj = { ...this.registrationObj };
          LocalStorageService.setItem("registration_legacy", this.registrationObj);

          const changed = spectators.some((spectator) =>
          {
            const previous = previousSpectators.find((item) => item.userId == spectator.userId);
            if (!previous) {
              return false;
            }

            return previous.eventWaiver !== spectator.eventWaiver ||
              previous.eventWaiverCode !== spectator.eventWaiverCode ||
              previous.eventWaiverId !== spectator.eventWaiverId;
          });

          if (!changed && retriesLeft > 0) {
            setTimeout(() => this.refreshEventWaiverStatus(index, retriesLeft - 1), 1500);
          }
        }
      });

    },
    refresStep()
    {
      LocalStorageService.removeItem('registration_legacy');
      LocalStorageService.setItem('active_event_registration', false);
      this.$store.dispatch('setLoadingPageAction', true);
      this.$emit("changeLoadingStep", true);
      this.registrationObj = {
        step: 1,
        promoters: [],
        promoterSel: null,
        events: [],
        eventSel: null,
        participants: [],
        partsSel: [],
        classE: [],
        brandsE: [],
        userId: 0,
        spectators: [],
        spectatorsSel: []
      };
      this.getLocalData();
    }
  },
  watch: {
    userStore(val)
    {
      if (val && !this.bandLoadUserStore)
      {
        this.loadUserStoreInit(val);
      }
    }
  }
};
</script>

<style>
#cont_steps .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
  height: 23px;
}

#cont_steps .mb0 {
  margin-bottom: 0;
}

#cont_steps .hd {
  background-color: #1976d2;
  color: #ffffff !important;
}

#cont_steps .boxDate {
  text-align: center;
  background: gray;
  color: #fff;
  padding-top: 20px;
  padding-bottom: 10px;
}

#cont_steps .boxDate p {
  margin: 0;
}

#cont_steps .boxDate p:first-child {
  font-size: 34px;
  font-weight: bold;
}

#cont_steps .boxDate p:last-child {
  font-size: 18px;
  text-transform: uppercase;
}

#cont_steps .spr {
  font-style: italic;
  display: block;
  font-size: 12px;
}

#cont_steps .boxTime {
  text-align: left;
}

#cont_steps .boxTime p {
  margin: 0;
  font-size: 24px;
  letter-spacing: 2px;
  color: red;
}

#cont_steps .boxCurrency {
  text-align: center;
  font-size: 17px;
  background: #ccc;
  font-weight: bold;
}

#cont_steps .boxCurrency span {
  text-transform: uppercase;
}

#cont_steps .v-data-table {
  width: 100%;
}

#cont_steps .btnw {
  color: #fff !important;
}

#cont_steps thead tr {
  background: #ccc;
}

#cont_steps .grayC {
  background: #ccc;
}

#cont_steps .th2 {
  text-align: center !important;
  font-size: 14px !important;
  color: white !important;
  background: #1976d2;
}

.text-tooltip {
  max-width: 400px;
}

#cont_steps .btn_next {
  color: white !important;
}

.cresult {
  border-radius: 10px;
  min-height: 130px;
  cursor: pointer;
  background: #ccc !important;
}

.cresult:hover {
  background: gray !important;
}

.cresult .v-list-item {
  padding: 8px;
}

.cresult .v-list-item__content {
  margin-left: 15px;
}

.cresult2 {
  border-radius: 10px;
  min-height: 130px;
  cursor: pointer;
}

.cresult2 .v-list-item {
  padding: 8px;
}

.cresult2 .v-list-item__content {
  margin-left: 15px;
}

.text-small {
  font-size: small;
}

.list-events {
  padding-left: 0 !important;
}

.list-events li {
  list-style: none;
}

.iconSm {
  font-size: 20px !important;
  margin-right: 3px;
}

.fn {
  font-weight: 500;
}

.countdown {
  margin-bottom: 0;
  color: blue;
}

.countdown div {
  display: inline;
}

.countdown2 {
  margin-bottom: 0;
  color: #45615f;
}

.countdown2 div {
  display: inline;
}

.brand_part_nom {
  display: inline-block;
  margin-left: 10px;
  position: absolute;
  top: 0;
}

.img_card_event {
  width: 100%;
  max-width: 200px;
  max-height: 200px;
}

.img_card_event_2 {
  width: 100px;
  height: 100px;
}

#cont_steps .input_str .v-input__control {
  height: 40px;
}

#cont_steps .input_str .v-input__slot {
  min-height: 40px !important;
}

#cont_steps .input_str_2 .v-input__control {
  height: 54px;
  margin-bottom: 0px;
}

#cont_steps .input_str_3 .v-input__control {
  height: 42px;
}

#cont_steps .input_str_2 .v-input__slot {
  min-height: 36px !important;
  margin-bottom: 0 !important;
}

#cont_steps .input_str_2 .v-text-field__slot input,
#cont_steps .input_str .v-text-field__slot input {
  color: rgba(0, 0, 0, 0.8);
}

#cont_steps .input_str_2 .v-text-field__details {
  margin-bottom: 0px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.fieldset_custom {
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.4);
  padding-left: 8px;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.3);
}

.fieldset_custom ul {
  margin: 10px;
}

.fieldset_custom ul li {
  color: rgba(0, 0, 0, 0.8);
}

.fieldset_custom legend {
  font-size: 12px;
  ;
}

.col_button {
  text-align: right;
}

.timer_column,
.timer_column_tablet {
  display: none;
}

.align_col {
  text-align: right;
}

.hidden_sm_event_tablet {
  display: none;
}

.timerCard {
  position: absolute;
  left: 12px;
  bottom: 11px;
}

.exp_pan .v-expansion-panel-header__icon {
  margin-top: -22px !important;
}

.dt_part .v-data-footer__select .v-select {
  margin: 0px 0px 0px 34px;
}

.dt_part .v-data-table-header {
  background: #ccc;
}

.dt_part {
  padding: 0;
  margin: 0 !important;
  margin-bottom: 15px !important;
}

.content_card_event {
  margin-left: 24px;
}

.timer_container {
  display: inline;
  width: max-content;
}

#cont_steps .input_str_2 textarea {
  margin-top: 4px !important;
  color: rgba(0, 0, 0, .8) !important;
}

#cont_steps .header_events .input_str_2 {
  margin-left: 40px;
}

@media (max-width: 1024px) {
  .col_button {
    margin-top: 10px;
  }

  .hidden_sm {
    margin-left: 0;
  }

  .hidden_sm_tablet {
    display: none;
  }

  .hidden_sm_event {
    display: none;
  }

  .timer_column_tablet,
  .hidden_sm_event_tablet {
    display: inherit;
  }

  .exp_pan {
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
  }

  .promC {
    margin: 0;
    margin-bottom: 15px;
  }

  .promC .col-12 {
    padding-top: 0;
    padding-bottom: 0;
  }
}

@media (max-width: 600px) {
  .col_button {
    text-align: center;
    margin-top: 10px;
  }

  .hidden_sm {
    display: none;
  }

  .v-expansion-panel-content__wrap {
    padding-right: 12px;
    padding-left: 12px;
  }

  .list-events li {
    margin-bottom: 1px;
  }

  .col_img_event_2 {
    text-align: center;
  }

  .timer_column {
    display: inherit;
  }

  .hidden_sm_event {
    display: none;
  }

  .img_card_event {
    width: 80px;
    height: 80px;
  }

  .align_col {
    text-align: center;
  }

  .btn_summ {
    width: 100%;
    margin-top: 10px;
  }

  .timer_column_tablet,
  .hidden_sm_event_tablet {
    display: none;
  }

  .content_card_event {
    margin-left: 0;
  }

  .input_str_2 .v-input__control {
    height: auto;
  }
}

.next_rsp {
  max-width: 100%;
  min-height: 36px !important;
  height: auto !important;
}

.next_rsp span {
  max-width: 100%;
  white-space: normal;
  margin: 4px 0;
  display: block;
}

.v-data-table__wrapper {
  -webkit-overflow-scrolling: touch;
}
</style>

<style scoped>
@media (max-width: 600px) {
  .step-xs {
    padding: 24px 6px 16px !important;
  }
}

.stepSelected {
  background-color: rgb(49, 175, 212);
  border-color: rgb(49, 175, 212);
  color: white;
}
</style>
